

export const Data=[
    {
        id: 1,
        name:"Abdulrahman Amgad",
        description:"A really good job, all aspects of the project were followed step by step and with good results"
    },
    {
        id:2,
        name:"Jane Smith",
        description:"A really good job, all aspects of the project were followed step by step and with good results"
    },
    {
        id:3,
        name:"Jane Smith",
        description:"A really good job, all aspects of the project were followed step by step and with good results"
    }
];